import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';

class FormBanco11  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            opt_cuenta: [],
            cuenta_sel: null          
        };

        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.impsaldoscuentasbancarias = this.impsaldoscuentasbancarias.bind(this);
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0711');
        let fechaProceso = getFechaProcesoPorModulo('06');
        let fechaHasta = moment(fechaProceso, 'DD/MM/YYYY');

        cargarCatalogos_Otros('BAN-CTASDEP').then((cuentas)=>{

            this.setState({
                fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
                fechaDesde: moment(fechaHasta.subtract(30, 'days')),
                opt_cuenta: cuentas
            });
        })
        .catch((error)=>{
            alert('Parametros de sistema no han sido cargados.')
        })
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0711');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('07');
        let fechaHasta = moment(fechaProceso, 'DD/MM/YYYY');

        this.setState({
            fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaDesde: moment(fechaHasta.subtract(30, 'days')),
            cuenta_sel: null,
            opt_cuenta: []          
        });
    }

    impsaldoscuentasbancarias(){
        try{
            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }

            if(!this.state.cuenta_sel){
                alert(`Debe seleccionar una cuenta para consultar`);
                return;
            }

            let urlReportWithParams=`&rpt=75`;

            urlReportWithParams+=`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
            urlReportWithParams+=`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;
            urlReportWithParams+=`&param3=${this.state.cuenta_sel.value}`;
            

            visualizarReporteEnPdf(urlReportWithParams);
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Saldos de cuentas bancarias</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Cuenta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelect options={ this.state.opt_cuenta } value={this.state.cuenta_sel} func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({cuenta_sel: value});}}/>
                        </ContainerCol>
                    </Row>     
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.impsaldoscuentasbancarias}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormBanco11);